/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Required_Edit_PatternsInputs */



/**
* | output |
* | --- |
* | "Compliance must be enabled to edit patterns." |
*
* @param {Compliance_Required_Edit_PatternsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_required_edit_patterns = /** @type {((inputs?: Compliance_Required_Edit_PatternsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Required_Edit_PatternsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance muss aktiviert sein, um Muster zu bearbeiten.")
	return /** @type {LocalizedString} */ ("Compliance must be enabled to edit patterns.")
});